export const formatPhoneNumberForDisplay = (phone: string): string => {
  const digits = sanitizePhoneNumber(phone);
  if (!digits) return '';

  const area = digits.slice(0, 3);
  const middle = digits.slice(3, 6);
  const last = digits.slice(6, 10);

  if (digits.length < 4) {
    return `+1 (${area})`;
  }
  if (digits.length <= 6) {
    return `+1 (${area})-${middle}`;
  }
  return `+1 (${area})-${middle}-${last}`;
};

export const sanitizePhoneNumber = (phone: string): string => {
  if (!phone) return '';
  let digits = phone.replace(/[^\d]/g, '');
  if (digits.startsWith('1')) {
    digits = digits.substring(1);
  }
  return digits.substring(0, 10);
};

export const handlePhoneNumberChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  currentDigits: string,
  setter: (value: string) => void
) => {
  const newDigits = sanitizePhoneNumber(e.target.value);

  // If it's not a simple append or delete from the end...
  if (!newDigits.startsWith(currentDigits) && !currentDigits.startsWith(newDigits)) {
    // ...and it's a deletion (not a replacement)...
    if (newDigits.length < currentDigits.length) {
      // ...then truncate to prevent the "shifting" of digits.
      let i = 0;
      while (i < newDigits.length && i < currentDigits.length && newDigits[i] === currentDigits[i]) {
        i++;
      }
      setter(newDigits.substring(0, i));
      return;
    }
  }

  // For all other cases (append, delete from end, replacement), just accept the new digits.
  setter(newDigits);
};
